import React from 'react';
import { motion } from 'framer-motion';

const LoadingSkeleton = ({ type = 'page' }) => {
  // Skeleton for page-level loading
  if (type === 'page') {
    return (
      <div className="min-h-screen app-shell p-4 md:p-8">
        <div className="max-w-7xl mx-auto space-y-6">
          {/* Header skeleton */}
          <motion.div
            className="bg-white/10 dark:bg-white/5 backdrop-blur-md rounded-2xl p-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <div className="h-8 bg-white/20 dark:bg-white/10 rounded-lg w-1/3 mb-4"></div>
            <div className="h-4 bg-white/20 dark:bg-white/10 rounded-lg w-1/2"></div>
          </motion.div>

          {/* Cards skeleton */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <motion.div
                key={i}
                className="bg-white/10 dark:bg-white/5 backdrop-blur-md rounded-2xl p-6"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1, duration: 0.3 }}
              >
                <div className="h-32 bg-white/20 dark:bg-white/10 rounded-lg mb-4"></div>
                <div className="h-4 bg-white/20 dark:bg-white/10 rounded-lg w-3/4 mb-2"></div>
                <div className="h-4 bg-white/20 dark:bg-white/10 rounded-lg w-1/2"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Skeleton for card-level loading
  if (type === 'card') {
    return (
      <div className="bg-white/10 dark:bg-white/5 backdrop-blur-md rounded-2xl p-6 animate-pulse">
        <div className="h-32 bg-white/20 dark:bg-white/10 rounded-lg mb-4"></div>
        <div className="h-4 bg-white/20 dark:bg-white/10 rounded-lg w-3/4 mb-2"></div>
        <div className="h-4 bg-white/20 dark:bg-white/10 rounded-lg w-1/2"></div>
      </div>
    );
  }

  // Skeleton for list item
  if (type === 'list') {
    return (
      <div className="space-y-3">
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="bg-white/10 dark:bg-white/5 backdrop-blur-md rounded-xl p-4 animate-pulse"
          >
            <div className="flex items-center gap-4">
              <div className="h-12 w-12 bg-white/20 dark:bg-white/10 rounded-full"></div>
              <div className="flex-1">
                <div className="h-4 bg-white/20 dark:bg-white/10 rounded-lg w-1/3 mb-2"></div>
                <div className="h-3 bg-white/20 dark:bg-white/10 rounded-lg w-1/2"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return null;
};

export default LoadingSkeleton;

